document.addEventListener("DOMContentLoaded", () => {
  const drawer = document.querySelector("[data-cart-drawer]");
  if (!drawer) return;

  const body = document.body;
  const itemsContainer = drawer.querySelector("[data-cart-items]");
  const emptyState = drawer.querySelector("[data-cart-empty]");
  const subtotalEl = drawer.querySelector("[data-cart-subtotal]");
  const shippingTotalEl = drawer.querySelector("[data-cart-shipping-total]");
  const grandTotalEl = drawer.querySelector("[data-cart-grand-total]");
  const drawerCountBadge = drawer.querySelector("[data-cart-count-badge]");
  const headerCountBadges = document.querySelectorAll("[data-cart-count]");
  const discountInput = drawer.querySelector("[data-cart-discount-input]");
  const discountFeedback = drawer.querySelector("[data-cart-discount-feedback]");
  const shippingZipInput = drawer.querySelector("[data-cart-shipping-zip]");
  const shippingFeedback = drawer.querySelector("[data-cart-shipping-feedback]");
  const shippingRatesContainer = drawer.querySelector("[data-cart-shipping-rates]");
  const checkoutButton = drawer.querySelector("[data-cart-checkout]");
  const freteGratisRoot = drawer.querySelector("[data-zr-frete-gratis-progress]");
  const freteGratisTexto = drawer.querySelector("[data-zr-frete-gratis-texto]");
  const freteGratisTrack = drawer.querySelector("[data-zr-frete-gratis-track]");
  const freteGratisBarra = drawer.querySelector("[data-zr-frete-gratis-bar]");

  const STORAGE_KEYS = {
    discount: "mf-cart-discount-code",
    zip: "mf-cart-shipping-zip",
    selectedRate: "mf-cart-selected-rate"
  };

  let cart = null;
  let shippingRates = [];
  let selectedShippingRate = null;
  let isLoadingShipping = false;
  let shippingRequestSeq = 0;

  const formatMoney = (cents) => {
    return (Number(cents || 0) / 100).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL"
    });
  };

  const setFeedbackMessage = (element, message) => {
    if (!element) return;
    const text = String(message || "").trim();
    element.textContent = text;
    element.hidden = !text;
  };

  const escapeHtml = (value) => {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  };

  const normalizeZip = (value) => {
    const digits = String(value || "").replace(/\D/g, "").slice(0, 8);
    return digits.length > 5 ? `${digits.slice(0, 5)}-${digits.slice(5)}` : digits;
  };

  const getRateKey = (rate) => {
    return [
      rate.presentment_name || rate.name || "",
      rate.price || 0,
      rate.currency || "BRL"
    ].join("|");
  };

  const setDrawerOpen = (open) => {
    drawer.classList.toggle("active", open);
    body.classList.toggle("mf-cart-drawer-open", open);
  };

  /* CUPOM OCULTO (2026-10-09): campo desativado — nunca lê nem aplica desconto. */
  const getStoredDiscount = () => {
    try { localStorage.removeItem(STORAGE_KEYS.discount); } catch (e) {}
    return "";
  };
  const getStoredZip = () => localStorage.getItem(STORAGE_KEYS.zip) || "";
  const getStoredRateKey = () => localStorage.getItem(STORAGE_KEYS.selectedRate) || "";

  const syncCountBadges = (count) => {
    const safeCount = Number(count || 0);

    if (drawerCountBadge) {
      drawerCountBadge.textContent = safeCount;
    }

    headerCountBadges.forEach((badge) => {
      badge.textContent = safeCount;
      badge.classList.toggle("is-hidden", safeCount === 0);
    });
  };

  const renderTotals = () => {
    const subtotal = Number(cart && cart.total_price ? cart.total_price : 0);
    const shippingPrice = selectedShippingRate ? Number(selectedShippingRate.price || 0) * 100 : 0;
    const total = subtotal + shippingPrice;

    subtotalEl.textContent = formatMoney(subtotal);
    shippingTotalEl.textContent = selectedShippingRate ? formatMoney(shippingPrice) : "A calcular";
    grandTotalEl.textContent = formatMoney(total);
  };

  /* ------------------------------------------------------------------
     Frete grátis — barra de progresso (somente informativa).

     A lista de produtos participantes vem renderizada pelo Liquid no
     servidor (#ZrFreteGratisDados) e, quando truncada (colecao maior que o
     teto do Liquid), e completada via <colecaoUrl>/products.json (ZR FRETE
     58, 2026-10-10). Ate completar, a barra fica oculta (fail-closed). O JS
     nao identifica colecao por nome, nao conhece nome de produto e nao
     mantem lista de IDs propria.

     Esta rotina NÃO calcula, não altera e não substitui tarifas de frete:
     lê apenas o carrinho (/cart.js) e o subtotal dos itens participantes.
     ------------------------------------------------------------------ */
  const freteGratisConfig = (() => {
    const el = document.getElementById("ZrFreteGratisDados");
    if (!el) return null;

    try {
      const data = JSON.parse(el.textContent);
      if (!data || !data.ativo) return null;
      data.ids = new Set((data.produtos || []).map(Number));
      data.completo = !(Number(data.esperado || 0) > data.ids.size);

      /* ZR FRETE 58: completa a lista via products.json (publico, same-origin).
         Sem isto, produtos alem do teto do Liquid (ex.: poliamidas ativadas)
         nao contariam no progresso nem no split. */
      if (!data.completo && data.colecaoUrl) {
        fetch(data.colecaoUrl.replace(/\/$/, "") + "/products.json?limit=250", {
          headers: { Accept: "application/json" }
        })
          .then((r) => (r.ok ? r.json() : null))
          .then((j) => {
            if (!j || !Array.isArray(j.products) || !j.products.length) return;
            j.products.forEach((p) => {
              if (p && p.id) data.ids.add(Number(p.id));
            });
            data.completo = !(Number(data.esperado || 0) > data.ids.size);
            renderFreteGratis();
          })
          .catch(() => {});
      }

      return data;
    } catch (error) {
      console.error("[frete-gratis] Nao foi possivel ler os dados da promocao.", error);
      return null;
    }
  })();

  let freteGratisTruncadoAvisado = false;

  const renderFreteGratis = () => {
    if (!freteGratisRoot) return;

    /* Promocao desligada ou sem dados: garante a barra oculta. */
    if (!freteGratisConfig) {
      freteGratisRoot.hidden = true;
      return;
    }

    const ids = freteGratisConfig.ids;
    const minimo = Number(freteGratisConfig.minimo || 0);
    const esperado = Number(freteGratisConfig.esperado || 0);

    /* Lista ainda incompleta (completude via products.json pendente):
       mantem oculto ate completar — fail-closed. */
    if (!freteGratisConfig.completo) {
      freteGratisRoot.hidden = true;
      return;
    }

    /* Sem coleção, sem mínimo ou lista incompleta: nao exibe nada.
       Preferimos ocultar a arriscar um numero errado para o cliente. */
    if (!ids.size || minimo <= 0 || esperado > ids.size) {
      if (ids.size && minimo > 0 && esperado > ids.size && !freteGratisTruncadoAvisado) {
        freteGratisTruncadoAvisado = true;
        console.error(
          "[frete-gratis] A colecao tem " + esperado + " produtos, mas o tema enumerou " + ids.size +
          ". A barra foi ocultada para nao informar um valor incorreto."
        );
      }
      freteGratisRoot.hidden = true;
      return;
    }

    const itens = cart && Array.isArray(cart.items) ? cart.items : [];
    const participantes = itens.filter((item) => ids.has(Number(item.product_id)));

    if (!participantes.length) {
      freteGratisRoot.hidden = true;
      return;
    }

    const subtotalElegivel = participantes.reduce(
      (soma, item) => soma + Number(item.final_line_price || 0),
      0
    );
    const faltante = Math.max(0, minimo - subtotalElegivel);
    const progresso = Math.min(100, (subtotalElegivel / minimo) * 100);
    const completo = faltante === 0;

    /* Carrinho misto: existem itens de OUTRAS colecoes alem dos
       participantes. Nesse caso a tarifa gratuita NAO aparece no checkout
       (a Shopify descarta tarifas que existem em um perfil so), entao
       anunciar "frete gratis liberado" seria uma promessa falsa.
       Quem trata o misto e o bloco de divisao do carrinho. */
    const temNaoParticipante = itens.length > participantes.length;

    const mensagem = completo
      ? String(
          (temNaoParticipante ? freteGratisConfig.msgOkMisto : freteGratisConfig.msgOk) ||
            "Frete gratis liberado!"
        )
      : String(freteGratisConfig.msgFalta || "Faltam {valor} para o frete gratis")
          .replace("{valor}", formatMoney(faltante));

    freteGratisRoot.hidden = false;
    freteGratisRoot.classList.toggle("is-complete", completo);

    if (freteGratisBarra) {
      freteGratisBarra.style.width = progresso.toFixed(2) + "%";
    }

    if (freteGratisTrack) {
      freteGratisTrack.setAttribute("aria-valuenow", String(Math.round(progresso)));
    }

    if (freteGratisTexto && freteGratisTexto.textContent !== mensagem) {
      freteGratisTexto.textContent = mensagem;
    }
  };

  const renderShippingRates = () => {
    shippingRatesContainer.innerHTML = "";

    if (!shippingRates.length) {
      if (!isLoadingShipping) {
        selectedShippingRate = null;
        renderTotals();
      }
      return;
    }

    const storedRateKey = getStoredRateKey();
    if (!selectedShippingRate) {
      selectedShippingRate = shippingRates.find((rate) => getRateKey(rate) === storedRateKey) || shippingRates[0];
    }

    shippingRates.forEach((rate) => {
      const button = document.createElement("button");
      button.type = "button";
      button.className = "mf-cart-drawer__shipping-rate";
      button.setAttribute("data-cart-rate-key", getRateKey(rate));
      button.classList.toggle("is-active", selectedShippingRate && getRateKey(selectedShippingRate) === getRateKey(rate));

      const rawName = rate.presentment_name || rate.name || "Entrega";
      const cleanedName = String(rawName).replace(/\s*\(Melhor Envio\)\s*/i, "").trim();
      const formattedName = cleanedName.replace(/(Correios\s+\w+(?:\s+\w+)?)/i, "$1 (Melhor Envio)");

      const deliveryDays = Array.isArray(rate.delivery_days) ? rate.delivery_days : null;
      let deliveryLabel = "";
      if (deliveryDays && deliveryDays.length === 2) {
        deliveryLabel = deliveryDays[0] === deliveryDays[1]
          ? `${deliveryDays[0]} dias uteis`
          : `${deliveryDays[0]} a ${deliveryDays[1]} dias uteis`;
      }

      button.innerHTML = `
        <span class="mf-cart-drawer__shipping-rate-name">${escapeHtml(formattedName)}</span>
        ${deliveryLabel ? `<small class="mf-cart-drawer__shipping-rate-days">${escapeHtml(deliveryLabel)}</small>` : ""}
        <strong class="mf-cart-drawer__shipping-rate-price">${formatMoney(Number(rate.price || 0) * 100)}</strong>
      `;
      shippingRatesContainer.appendChild(button);
    });

    renderTotals();
  };

  const renderCartItems = () => {
    if (!cart || !Array.isArray(cart.items) || !cart.items.length) {
      itemsContainer.innerHTML = "";
      emptyState.classList.remove("is-hidden");
      shippingRates = [];
      selectedShippingRate = null;
      shippingRatesContainer.innerHTML = "";
      renderFreteGratis();
      renderTotals();
      syncCountBadges(0);
      return;
    }

    emptyState.classList.add("is-hidden");
    itemsContainer.innerHTML = cart.items.map((item, index) => {
      const image = item.image
        ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.product_title)}">`
        : `<div class="mf-cart-drawer__item-image-placeholder"></div>`;

      const variantTitle = item.variant_title && item.variant_title !== "Default Title"
        ? `<small>${escapeHtml(item.variant_title)}</small>`
        : "";

      return `
        <article class="mf-cart-drawer__item" data-cart-line="${index + 1}">
          <div class="mf-cart-drawer__item-image">
            ${image}
          </div>

          <div class="mf-cart-drawer__item-content">
            <div class="mf-cart-drawer__item-top">
              <div class="mf-cart-drawer__item-info">
                <strong>${escapeHtml(item.product_title)}</strong>
                ${variantTitle}
              </div>

              <button type="button" class="mf-cart-drawer__remove" data-cart-remove aria-label="Remover item">
                x
              </button>
            </div>

            <div class="mf-cart-drawer__item-bottom">
              <div class="mf-cart-drawer__qty">
                <button type="button" data-cart-qty-minus aria-label="Diminuir quantidade">-</button>
                <input type="number" min="0" value="${Number(item.quantity || 0)}" data-cart-item-qty>
                <button type="button" data-cart-qty-plus aria-label="Aumentar quantidade">+</button>
              </div>

              <strong class="mf-cart-drawer__item-price">${formatMoney(item.final_line_price)}</strong>
            </div>
          </div>
        </article>
      `;
    }).join("");

    syncCountBadges(cart.item_count);
    renderFreteGratis();
    renderTotals();
  };

  const renderDiscount = () => {
    const discount = getStoredDiscount();
    if (discountInput) {
      discountInput.value = discount;
    }

    setFeedbackMessage(discountFeedback, "");
  };

  const requestCart = async () => {
    const response = await fetch("/cart.js", {
      headers: {
        Accept: "application/json"
      }
    });

    if (!response.ok) {
      throw new Error("Nao foi possivel carregar o carrinho.");
    }

    return response.json();
  };

  const refreshCart = async (options = {}) => {
    const { recalculateShipping = true } = options;

    cart = await requestCart();
    renderCartItems();

    if (recalculateShipping) {
      const storedZip = getStoredZip();
      if (storedZip && cart.item_count > 0) {
        calculateShipping(storedZip, true);
      }
    }
  };

  const changeLineQuantity = async (line, quantity) => {
    const safeQuantity = Math.max(0, parseInt(quantity, 10) || 0);

    await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({
        line,
        quantity: safeQuantity
      })
    });

    await refreshCart();
  };

  const addToCart = async (form) => {
    const submitButton = form.querySelector('[type="submit"]');
    const previousText = submitButton ? submitButton.textContent : "";

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = "Adicionando...";
    }

    try {
      const formData = new FormData(form);
      const variantId = Number(formData.get("id"));
      const quantity = Math.max(1, parseInt(formData.get("quantity") || "1", 10) || 1);

      const cartResponse = await fetch("/cart.js", { headers: { Accept: "application/json" } });
      const currentCart = await cartResponse.json();

      const existing = (currentCart.items || []).find(function(item) {
        return Number(item.variant_id) === variantId;
      });

      let response;
      if (existing) {
        const newQty = Number(existing.quantity || 0) + quantity;
        response = await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ id: existing.key, quantity: newQty })
        });
      } else {
        response = await fetch("/cart/add.js", {
          method: "POST",
          headers: { Accept: "application/json" },
          body: formData
        });
      }

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.description || "Nao foi possivel adicionar o produto.");
      }

      await refreshCart({ recalculateShipping: true });
      setDrawerOpen(true);
    } finally {
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.textContent = previousText;
      }
    }
  };

  const pollShippingRates = async (zipDigits, requestSeq) => {
    const url = `/cart/async_shipping_rates.json?shipping_address%5Bzip%5D=${zipDigits}&shipping_address%5Bcountry%5D=Brazil`;

    for (let attempt = 0; attempt < 20; attempt += 1) {
      if (requestSeq !== undefined && requestSeq !== shippingRequestSeq) {
        throw new Error("superseded");
      }

      const response = await fetch(url, {
        headers: {
          Accept: "application/json"
        }
      });
      const data = await response.json();

      if (Array.isArray(data.shipping_rates) && data.shipping_rates.length > 0) {
        return data.shipping_rates;
      }

      if (data && data.token) {
        window.setTimeout(() => {}, 0);
      }

      await new Promise((resolve) => {
        window.setTimeout(resolve, 800);
      });
    }

    throw new Error("Nao foi possivel consultar o frete agora.");
  };

  const calculateShipping = async (zipValue, silent) => {
    const zip = normalizeZip(zipValue);
    const zipDigits = zip.replace(/\D/g, "");

    if (shippingZipInput) {
      shippingZipInput.value = zip;
    }

    if (!cart || cart.item_count === 0) {
      setFeedbackMessage(shippingFeedback, "Adicione produtos ao carrinho para calcular o frete.");
      shippingRates = [];
      selectedShippingRate = null;
      renderShippingRates();
      return;
    }

    if (zipDigits.length !== 8) {
      setFeedbackMessage(shippingFeedback, "Digite um CEP valido com 8 numeros.");
      return;
    }

    const requestSeq = ++shippingRequestSeq;

    isLoadingShipping = true;
    setFeedbackMessage(shippingFeedback, silent
      ? "Atualizando opcoes de entrega..."
      : `Calculando frete para o CEP ${zip}...`);

    localStorage.setItem(STORAGE_KEYS.zip, zip);

    let province = null;
    try {
      const viaCepResponse = await fetch(`https://viacep.com.br/ws/${zipDigits}/json/`);
      if (viaCepResponse.ok) {
        const viaCepData = await viaCepResponse.json();
        if (viaCepData && !viaCepData.erro && viaCepData.uf) {
          province = viaCepData.uf;
        }
      }
    } catch (error) {
      province = null;
    }

    const payload = new URLSearchParams();
    payload.set("shipping_address[zip]", zipDigits);
    payload.set("shipping_address[country]", "Brazil");
    if (province) payload.set("shipping_address[province]", province);

    try {
      await fetch("/cart/prepare_shipping_rates.json", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
          Accept: "application/json"
        },
        body: payload.toString()
      });

      if (requestSeq !== shippingRequestSeq) return;

      shippingRates = await pollShippingRates(zipDigits, requestSeq);

      if (requestSeq !== shippingRequestSeq) return;

      if (!shippingRates.length) {
        selectedShippingRate = null;
        setFeedbackMessage(shippingFeedback, "Nenhuma opcao de entrega encontrada para esse CEP.");
      } else {
        const storedRateKey = getStoredRateKey();
        selectedShippingRate = shippingRates.find((rate) => getRateKey(rate) === storedRateKey) || shippingRates[0];
        localStorage.setItem(STORAGE_KEYS.selectedRate, getRateKey(selectedShippingRate));
        setFeedbackMessage(shippingFeedback, "");
      }
    } catch (error) {
      if (requestSeq !== shippingRequestSeq) return;
      shippingRates = [];
      selectedShippingRate = null;
      setFeedbackMessage(shippingFeedback, error.message || "Nao foi possivel calcular o frete agora.");
    } finally {
      if (requestSeq === shippingRequestSeq) {
        isLoadingShipping = false;
        renderShippingRates();
      }
    }
  };

  document.addEventListener("click", async (event) => {
    const openTrigger = event.target.closest("[data-open-cart-drawer]");
    if (openTrigger) {
      event.preventDefault();
      try {
        await refreshCart();
      } catch (error) {
        console.error(error);
      }
      setDrawerOpen(true);
      return;
    }

    if (event.target.closest("[data-cart-close]")) {
      event.preventDefault();
      setDrawerOpen(false);
      return;
    }

    const discountSaveButton = event.target.closest("[data-cart-discount-save]");
    if (discountSaveButton) {
      /* CUPOM OCULTO (2026-10-09): ignora qualquer tentativa de aplicar cupom. */
      try { localStorage.removeItem(STORAGE_KEYS.discount); } catch (e) {}
      renderDiscount();
      return;
    }

    const shippingButton = event.target.closest("[data-cart-shipping-calculate]");
    if (shippingButton) {
      await calculateShipping(shippingZipInput.value, false);
      return;
    }

    const shippingRateButton = event.target.closest("[data-cart-rate-key]");
    if (shippingRateButton) {
      const selectedKey = shippingRateButton.getAttribute("data-cart-rate-key");
      selectedShippingRate = shippingRates.find((rate) => getRateKey(rate) === selectedKey) || null;

      if (selectedShippingRate) {
        localStorage.setItem(STORAGE_KEYS.selectedRate, selectedKey);
      } else {
        localStorage.removeItem(STORAGE_KEYS.selectedRate);
      }

      renderShippingRates();
      return;
    }

    const qtyButton = event.target.closest("[data-cart-qty-minus], [data-cart-qty-plus], [data-cart-remove]");
    if (qtyButton) {
      const item = qtyButton.closest("[data-cart-line]");
      if (!item) return;

      const line = Number(item.getAttribute("data-cart-line"));
      const qtyInput = item.querySelector("[data-cart-item-qty]");
      const currentQty = Math.max(0, parseInt(qtyInput.value || "0", 10) || 0);

      if (qtyButton.hasAttribute("data-cart-remove")) {
        await changeLineQuantity(line, 0);
        return;
      }

      const nextQty = qtyButton.hasAttribute("data-cart-qty-plus") ? currentQty + 1 : currentQty - 1;
      await changeLineQuantity(line, nextQty);
      return;
    }

    const checkoutTrigger = event.target.closest("[data-cart-checkout]");
    if (checkoutTrigger) {
      /* CUPOM OCULTO (2026-10-09): vai direto ao checkout, sem /discount/. */
      let baseUrl = drawer.getAttribute("data-checkout-url") || "/checkout";
      const storedZip = getStoredZip();
      const zipDigits = (storedZip || "").replace(/\D/g, "").slice(0, 8);
      if (zipDigits.length === 8) {
        const sep = baseUrl.indexOf("?") === -1 ? "?" : "&";
        baseUrl = baseUrl + sep + "shipping_address[zip]=" + zipDigits;
      }
      try { localStorage.removeItem(STORAGE_KEYS.discount); } catch (e) {}
      window.location.href = baseUrl;
    }
  });

  document.addEventListener("change", async (event) => {
    const qtyInput = event.target.closest("[data-cart-item-qty]");
    if (qtyInput) {
      const item = qtyInput.closest("[data-cart-line]");
      if (!item) return;

      const line = Number(item.getAttribute("data-cart-line"));
      const nextQty = Math.max(0, parseInt(qtyInput.value || "0", 10) || 0);
      qtyInput.value = nextQty;
      await changeLineQuantity(line, nextQty);
      return;
    }

    const zipInput = event.target.closest("[data-cart-shipping-zip]");
    if (zipInput) {
      zipInput.value = normalizeZip(zipInput.value);
    }
  });

  document.addEventListener("submit", async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.closest("[data-cart-drawer]")) return;

    const action = form.getAttribute("action") || "";
    const isAddToCartForm = form.matches(".product-form, [data-cart-add-form]") || action.indexOf("/cart/add") !== -1;
    if (!isAddToCartForm) return;

    event.preventDefault();

    try {
      await addToCart(form);
    } catch (error) {
      window.alert(error.message || "Nao foi possivel adicionar o produto.");
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && drawer.classList.contains("active")) {
      setDrawerOpen(false);
    }
  });

  renderDiscount();

  if (shippingZipInput) {
    shippingZipInput.value = getStoredZip();
  }

  refreshCart().catch((error) => {
    console.error(error);
  });

  document.addEventListener("cart:refresh", function(event) {
    if (!event || !event.detail) return;
    var count = Number(event.detail.count || 0);
    if (drawerCountBadge) drawerCountBadge.textContent = count;
    headerCountBadges.forEach(function(badge) {
      badge.textContent = count;
      badge.classList.toggle('is-hidden', count === 0);
    });
  });

  /* Mudancas de carrinho feitas por outros scripts (ex.: reposicao do carrinho
     depois da simulacao de frete na pagina de produto). Releitura somente de
     leitura: nao cota frete e nao toca em /cart/prepare_shipping_rates.json. */
  let freteGratisSyncTimer = null;
  document.addEventListener("zafer:cart-updated", function() {
    window.clearTimeout(freteGratisSyncTimer);
    freteGratisSyncTimer = window.setTimeout(function() {
      refreshCart({ recalculateShipping: false }).catch(function(error) {
        console.error(error);
      });
    }, 150);
  });
});
